// 定义全局 filter
import Vue from "vue";
import FormatUtil from "@/utils/u-format.js";

Vue.filter("formatDate", (time, type) => {
  if (!time) {
    return "";
  }
  let date = new Date(time * 1000);
  return FormatUtil.formatDate(date, type || "yyyy-MM-dd hh:mm:ss");
});
Vue.filter("secToDate", (time) => {
  if (!time) {
    return "";
  }
  return FormatUtil.secondToDate(time);
});

